import type { InputManager } from './input';

/**
 * Joystick virtuale touch (DOM): appare in basso a sinistra sui dispositivi
 * touch, con un pulsante azione "A" in basso a destra.
 */

export function createTouchControls(uiRoot: HTMLElement, input: InputManager): void {
  const isTouch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
  if (!isTouch) return;

  const RADIUS = 56;

  const joystick = document.createElement('div');
  joystick.className = 'joystick';
  const knob = document.createElement('div');
  knob.className = 'joystick-knob';
  joystick.appendChild(knob);

  const actionBtn = document.createElement('button');
  actionBtn.className = 'touch-action';
  actionBtn.textContent = 'A';
  actionBtn.setAttribute('aria-label', 'Interagisci');

  const menuBtn = document.createElement('button');
  menuBtn.className = 'touch-menu';
  menuBtn.textContent = '☰';
  menuBtn.setAttribute('aria-label', 'Menu');

  uiRoot.append(joystick, actionBtn, menuBtn);

  let activePointer: number | null = null;

  const updateFromEvent = (e: PointerEvent) => {
    const rect = joystick.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    let dx = (e.clientX - cx) / RADIUS;
    let dy = (e.clientY - cy) / RADIUS;
    const len = Math.hypot(dx, dy);
    if (len > 1) {
      dx /= len;
      dy /= len;
    }
    knob.style.transform = `translate(${dx * RADIUS * 0.5}px, ${dy * RADIUS * 0.5}px)`;
    // dead zone per evitare drift
    const dead = 0.18;
    input.setTouchAxis(Math.abs(dx) < dead ? 0 : dx, Math.abs(dy) < dead ? 0 : dy);
  };

  const reset = () => {
    activePointer = null;
    knob.style.transform = 'translate(0, 0)';
    input.setTouchAxis(0, 0);
  };

  joystick.addEventListener('pointerdown', (e) => {
    activePointer = e.pointerId;
    joystick.setPointerCapture(e.pointerId);
    updateFromEvent(e);
  });
  joystick.addEventListener('pointermove', (e) => {
    if (e.pointerId === activePointer) updateFromEvent(e);
  });
  joystick.addEventListener('pointerup', reset);
  joystick.addEventListener('pointercancel', reset);

  actionBtn.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    input.fire('interact');
  });
  menuBtn.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    input.fire('menu');
  });
}
